import { render } from "./banner.vue?vue&type=template&id=64dd42c8&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=64dd42c8&lang=scss&scoped=true"

import exportComponent from "/Users/yue/Documents/其他项目/数字转创/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dd42c8"]])

export default __exports__